/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { sendRequest } from '../../../api/shootAPI';
import API from '../../../api/endpoints';
import { UserContext } from '../../../contexts/User';
import CriticalAlerts from './CriticalAlerts';
import TeamPerformance from './TeamPerformance';
import BotAlerts from './BotAlerts';

const TABS = [
  { key: 0, label: 'Critical Alerts', countKey: 'critical' },
  { key: 1, label: 'Team Performance' },
  { key: 2, label: 'HR Bot Alerts', countKey: 'hrBot' },
  { key: 3, label: 'IT Bot Alerts', countKey: 'itBot' },
  { key: 4, label: 'Infosec Bot Alerts', countKey: 'infosecBot' },
];

// `?tab=` opens the page on a specific bot, so the dashboard's "View all" links
// land on the alerts they came from instead of on Critical Alerts.
const TAB_BY_SLUG = {
  critical: 0, performance: 1, hr: 2, it: 3, infosec: 4,
};

function AlertsTabs() {
  const { activeWorkspace } = useContext(UserContext);
  const location = useLocation();
  const [value, setValue] = useState(
    () => TAB_BY_SLUG[new URLSearchParams(location.search).get('tab')] ?? 0,
  );
  const [counts, setCounts] = useState({ critical: 0, hrBot: 0, itBot: 0, infosecBot: 0 });

  const getAlertsCount = async () => {
    const response = await sendRequest({ method: 'get', url: API.WORKSPACE.getPendingAlertsCount(activeWorkspace.id) });
    if (response.status === 200 && Array.isArray(response.data.counts)) {
      const next = response.data.counts.reduce((acc, curr) => {
        // Critical isn't its own category — the backend returns a per-category
        // criticalCount (sum of priority='Critical'); total them for the badge.
        acc.critical += Number(curr.criticalCount) || 0;
        if (curr.category === 'HR') acc.hrBot = Number(curr.count) || 0;
        if (curr.category === 'IT') acc.itBot = Number(curr.count) || 0;
        if (curr.category === 'Infosec') acc.infosecBot = Number(curr.count) || 0;
        return acc;
      }, { critical: 0, hrBot: 0, itBot: 0, infosecBot: 0 });
      setCounts(next);
    }
  };

  useEffect(() => { getAlertsCount(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

  return (
    <div className="bg-white border border-rule rounded-[12px]" style={{ borderStyle: 'solid', boxShadow: '0 1px 3px rgba(14, 30, 64, 0.06)' }}>
      {/* Tab bar */}
      <div className="flex items-center gap-1 px-3 overflow-x-auto border-b border-rule" style={{ borderBottomStyle: 'solid' }}>
        {TABS.map((t) => {
          const active = value === t.key;
          const count = t.countKey ? counts[t.countKey] : 0;
          return (
            <button
              key={t.key}
              type="button"
              onClick={() => setValue(t.key)}
              className={`relative inline-flex items-center gap-2 px-4 py-3 text-sm bg-transparent border-0 cursor-pointer whitespace-nowrap transition ${active ? 'text-ink-900 font-semibold' : 'text-ink-500 font-medium hover:text-ink-900'}`}
            >
              {t.label}
              {count > 0 && (
                <span className="inline-flex items-center justify-center text-white rounded-full" style={{ background: '#CC4525', fontSize: 11, fontWeight: 600, minWidth: 20, height: 18, padding: '0 6px' }}>
                  {count}
                </span>
              )}
              {active && <span className="absolute left-2 right-2 bottom-0" style={{ height: 2, background: '#213d69', borderRadius: 2 }} />}
            </button>
          );
        })}
      </div>

      {/* Panel */}
      <div className="p-5">
        {value === 0 && <CriticalAlerts />}
        {value === 1 && <TeamPerformance />}
        {value === 2 && <BotAlerts category="HR" />}
        {value === 3 && <BotAlerts category="IT" />}
        {value === 4 && <BotAlerts category="Infosec" />}
      </div>
    </div>
  );
}

export default AlertsTabs;
